var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"locate-btn-view"},[_c('button',{staticClass:"locate-btn",on:{"click":_vm.getCurrentLocation}})])}
var staticRenderFns = []

export { render, staticRenderFns }